var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLuxemburg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 254,
    viewBox: "0 0 171 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_514_30948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9674 69.7209L36.1458 65.4234L47.4215 53.0243L68.5609 64.6379L62.5053 72.0709L65.368 81.2306L78.1915 67.1697L85.4128 72.1488L92.3816 69.3963L88.1977 65.2027L84.3377 53.5891L79.5127 35.2046L84.3377 20.6827L80.1539 15.8464L79.5127 4.5574L71.4624 2.62287L68.5674 8.42644L63.7423 8.75102L58.5935 0.36377L45.7181 2.94097L44.1055 17.1383L31.8778 21.6565L29.624 33.9128L23.1863 40.6836L24.7989 46.8182L23.5101 56.4908L16.4312 60.6845L16.1074 66.1699L19.9674 69.7209Z",
    fill: "#ABD4E6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3745 81.2502L68.1076 87.9107L62.5572 90.9553L61.1195 94.5063L52.8036 111.923L42.8038 106.73L38.7689 109.554L36.5993 104.516L23.1346 102.231L20.0194 110.878L9.72166 107.762L1.03662 100.342L8.11548 79.0496L19.9675 69.721L36.1459 65.4235L47.4216 53.0244L68.5545 64.638L62.5054 72.071L65.3745 81.2502Z",
    fill: "#ABD4E6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3817 69.3963L94.5643 77.1604L96.8181 74.5832L105.186 80.3867L104.862 88.1313L107.116 96.194L109.933 98.505L108.45 99.0308L98.0616 102.4L98.0745 94.3049L91.0928 89.6828L88.3209 82.9769L82.5309 89.6893L76.7603 84.7881L77.9714 75.8036L79.3638 68.5264L79.448 68.0396L85.4129 72.1488L92.3817 69.3963Z",
    fill: "#ABD4E6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.43 99.0371L98.0615 102.406L98.0745 94.3047L91.0928 89.6826L88.3208 82.9767L82.5308 89.6891L76.7602 84.7879L77.9713 75.8034L79.448 68.0393L78.185 67.1694L65.368 81.2304L68.1076 87.9104L62.5572 90.955L61.1064 94.5254L52.81 111.923L53.218 115.792L49.9927 116.402L52.2595 124.069L62.5442 121.005L63.0364 124.231H63.0688L96.1898 122.634L109.726 135.877L125.464 108.995L124.861 107.457L118.748 102.939L115.529 103.263L109.927 98.5048L108.43 99.0371Z",
    fill: "#ABD4E6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0039 124.011L62.5505 121.005L52.2658 124.082L49.999 116.403L53.2243 115.799L52.8033 111.924L42.8165 106.737L38.7687 109.554L36.5861 104.517L23.1343 102.231L20.0256 110.878L9.6696 107.73L3.8731 108.373L0.336914 124.504L4.83811 138.377L10.6346 136.118L21.8973 151.925L23.8273 162.572L28.9762 160.313L33.16 165.473L57.9069 159.365L63.0492 124.258L63.0039 124.011Z",
    fill: "#ABD4E6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.179 186.837L116.461 171.024L99.104 166.187L114.589 148.114L114.732 147.952L126.636 154.846L141.331 154.47L142.335 147.952L152.127 155.93L157.451 152.62L168.578 153.976L151.201 173.659L154.096 176.886L146.694 193.978L144.168 197.698L143.876 197.555L125.036 188.304L124.751 188.071L125.179 186.837Z",
    fill: "#ABD4E6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.036 188.305L144.168 197.698L141.81 200.119L142.775 203.67L138.267 206.572L142.451 211.733L141.81 215.284L138.267 222.704L140.197 233.35L140.521 244.639L132.795 242.056L122.821 237.219L119.926 232.058L111.558 229.799L108.657 220.12L118.961 204.638L124.751 188.071L125.036 188.305Z",
    fill: "#ABD4E6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2652 173.938L79.7132 169.148L86.0797 169.349L89.305 172.212H102.595L116.468 171.024L99.104 166.187L118.734 143.285L109.713 135.865L96.1895 122.641L63.0426 124.251L57.9067 159.358L58.8199 167.181L70.7432 168.161L72.2199 173.796L72.2652 173.938Z",
    fill: "#ABD4E6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2653 173.951L79.7327 169.154L86.0991 169.355L89.3245 172.218H102.614L116.468 171.023L125.179 186.837L118.961 204.637L108.663 220.114L94.8619 222.671L93.8969 215.894L74.5839 204.605L62.4209 208.13L59.8433 199.418L73.9492 180.41L72.4466 174.691L72.2653 173.951Z",
    fill: "#ABD4E6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7994 206.02L62.4276 208.13L74.5841 204.605L93.8907 215.894L94.8557 222.671L108.664 220.114L111.565 229.793L111.559 229.799L96.4683 232.026L81.663 251.059L74.5841 246.866L70.0764 253.637L55.9122 250.735L54.3061 238.803L38.8595 237.187L33.063 237.829L19.2227 223.314L30.2198 212.473L30.3429 212.174L34.5138 218.296L50.7958 211.733L54.4356 215.018L57.771 208.617L60.7761 206.52L61.7994 206.02Z",
    fill: "#ABD4E6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3492 212.175L34.5201 218.296L50.8021 211.727L54.4419 215.011L57.7773 208.611L60.7824 206.514L61.7992 206.02L59.785 199.438L73.9427 180.411L70.7239 168.148L58.82 167.181L57.9068 159.365L33.1665 165.473L33.0369 165.798L29.5331 170.407L28.8855 175.243L37.577 179.762L38.542 186.857L27.2793 205.891L33.0693 209.442L30.7248 211.947L30.3492 212.175Z",
    fill: "#ABD4E6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.732 147.952L126.642 154.84L141.331 154.476L142.335 147.952L152.127 155.93L157.464 152.62L168.578 153.976L167.01 147.803V131.028L170.547 122.966L159.608 120.064L154.459 123.284L147.056 122.316L136.752 112.319L132.892 109.736L128.067 114.578L125.476 108.976L125.463 109.002L109.732 135.878L118.734 143.285L114.732 147.952Z",
    fill: "#ABD4E6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.8824,
    cy: 131.71,
    rx: 5.02941,
    ry: 5.01316,
    fill: "#14557A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_514_30948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 254,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuxemburg);
export default __webpack_public_path__ + "static/media/luxemburg.4d5fe3185fd4428a5595ebb81dd3cc7c.svg";
export { ForwardRef as ReactComponent };